export default {
  root: {
    '& .MuiFormControl-root': {
      marginBottom: 0,
    },
  },
};
